export default __webpack_public_path__ + "static/media/toledo_7.c86bdac7.png";